export const usePageTitle = (title: string, includeSuffix = false, siteName?: string): string => {
  const siteTitle = siteName || null;

  if (!title) return siteTitle || '';

  if (!includeSuffix) return title;

  if (!siteTitle) {
    return title;
  }

  return `${title} | ${siteTitle}`;
};
